



























































import { SubEvent, EventExtraInfo, EventInfo, DateRange } from 'inscreva-sse-models';
import moment from 'moment';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { TemplateOptions } from '@/models/template';

import { EventDateHelper } from '../services/EventDateHelper';
import EventCard from './EventCard.vue';
import toast from './toast';
import { ToastType } from './toast/tost-type.enum';

@Component({
  components: {
    EventCard,
  },
})
export default class EventCardListComponent extends Vue {
  @Prop({ required: true })
  private subEvents!: Array<SubEvent>;

  @Prop({ required: true })
  private parentInfo!: EventExtraInfo & EventInfo;

  @Prop({ default: false })
  private isEditing: boolean;

  @Prop({
    default: () => ({
      title: 'Título',
      subTitle: 'Sub-Título',
    }),
  })
  private templateOptions: TemplateOptions;

  getFormattedDate(date: string): string {
    const momentDate = moment(date);
    return momentDate.format('DD/MM/YYYY');
  }

  getDate(subEvent: SubEvent): string {
    const { date } = subEvent.info;
    const sameDay: boolean = EventDateHelper.isSameDay(date);
    return (
      (date.start &&
        date.end &&
        ` ( ${this.getFormattedDate(date.start)}${!sameDay ? ` - ${this.getFormattedDate(date.end)}` : ''} | ${moment(
          date.start,
        ).format('HH:mm')} à ${moment(date.end).format('HH:mm')} )`) ||
      ''
    );
  }

  toggle(event: Event, index: number): void {
    this.$emit('on-list-change', {
      event: { ...event, expanded: false },
      index,
    });
  }

  favorite(event: Event) {
    this.$emit('on-favorite', event);
  }

  onEditImage({ imageBase64 }: { imageBase64: string }, index: number) {
    return this.$emit('on-edit-image', { imageBase64, index });
  }

  deleteSubEvent(index: number) {
    this.$emit('delete-event', index);
  }

  toggleSubEvent(index: number) {
    this.$emit('toggle-event', index);
  }

  confirmSubEvent(index: number) {
    this.toggleSubEvent(index);
    this.$emit('confirm-event', index);
  }

  findAnotherDateInRange(dates: Array<DateRange>, indexDate: number, isInterval: boolean): DateRange {
    return dates.find(
      (rangeToCompare, rangeIndex) =>
        rangeToCompare.interval === isInterval &&
        rangeIndex !== indexDate &&
        EventDateHelper.isBetween(dates[indexDate], rangeToCompare),
    );
  }

  hasAnotherDateInRange(indexSubEvent: number, indexDate: number, isInterval: boolean): boolean {
    return !!this.findAnotherDateInRange(this.subEvents[indexSubEvent].info.dates, indexDate, isInterval);
  }

  onUpdateInfo(info: EventInfo, indexSubEvent: number) {
    if (info.dates.some((date, indexDate) => this.hasAnotherDateInRange(indexSubEvent, indexDate, date.interval))) {
      toast(
        `Atenção ! Já existe ${
          info.dates.find((date, indexDate) => this.findAnotherDateInRange(info.dates, indexDate, date.interval))
            ?.interval
            ? 'Intervalo'
            : this.templateOptions.title
        } nesta faixa de horário`,
        ToastType.WARNING,
        {
          displayMode: 2,
        },
      );
    }
    this.subEvents.splice(
      indexSubEvent,
      1,
      Object.assign(this.subEvents[indexSubEvent], { info: Object.assign(this.subEvents[indexSubEvent].info, info) }),
    );
  }
}
